import { createContext, useContext, useReducer } from "react"
import { initialState, productReducer } from "../reducer"

const ProductStateContext = createContext();
const ProductDispatchContext = createContext();

export const ProductProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productReducer, initialState);

  return (
    <ProductStateContext.Provider value={state}>
      <ProductDispatchContext.Provider value={dispatch}>
        {children}
      </ProductDispatchContext.Provider>
    </ProductStateContext.Provider>
  )
}

export const useProductState = () => {
  const context = useContext(ProductStateContext);

  if (!context) throw Error('useProductState는 ProductProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductDispatch = () => {
  const context = useContext(ProductDispatchContext);

  if (!context) throw Error('useProductDispatch는 ProductProvider 내에서 사용해야 합니다.');
  return context;
}